import { mutatorAction } from "satcheljs";
import getRewardsPointsStore from "../store/rewardsPointsStore";

export const setRewardsPointsWidthMutator: (accountKey: string, widthPx: number) => void = mutatorAction("SET_REWARDS_POINTS_WIDTH", (accountKey: string, widthPx: number): void => {
    const store = getRewardsPointsStore();
    store.pointsWidthByAccount = { ...store.pointsWidthByAccount, [accountKey]: widthPx };
});
